import React, { useState } from "react";
import "./css/ContactUs.css"; // Import the CSS file
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from "react-spinners";
const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch("https://api.hxabyte.com/contact-mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, description }),
      });

      const result = await response.json();
      if (response.ok) {
        toast.success("Message sent successfully!");
        setName("");
        setEmail("");
        setDescription("");
      } else {
        toast.error(`Failed: ${result.error}`);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <p className="contact-description">
        For inquiries or assistance, please fill out the form below or contact
        us directly using the phone number provided.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={handleNameChange}
            required
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={handleEmailChange}
            required
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">Description:</label>
          <textarea
            id="description"
            name="description"
            value={description}
            onChange={handleDescriptionChange}
            required
            className="form-control"
          />
        </div>
        <button type="submit" className="btn-submit" disabled={isLoading}>
          {isLoading ? <ClipLoader size={20} color="#fff" /> : "Submit"}
        </button>
      </form>
      <div className="contact-info">
        <h2>Contact Information</h2>
        <p>
          <strong>Phone:</strong> 08248306704
        </p>
        <p>
          <strong>Email:</strong> hxabytetech@gmail.com
        </p>
        <p>
          <strong>ADDRESS:</strong> Hxabyte Records, 172/7 , Annai Thresa Nagar,
          Convent Road, New Fairlands, Salem 636016, Tamil Nadu, INDIA
        </p>
      </div>
      <p>This website was developed by Leonard Laureate</p>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default ContactUs;
